import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-view-payment',
  templateUrl: './modal-view-payment.component.html',
  styleUrls: ['./modal-view-payment.component.scss']
})
export class ModalViewPaymentComponent implements OnInit {

  organizations : any = [];
  duePayments: any = [];
  organizationForm: FormGroup = new FormGroup({
    customer_id: new FormControl(''),
    due_payment_id: new FormControl(''),
    amount: new FormControl(''),
    detail: new FormControl(''),
  });

  getOrganizations(){
    this.mService.get_request('organizations/list')
    .subscribe((resp: any)=>{
      if(resp.status){
        this.organizations = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  getDuePayments(id: string){
    this.mService.get_request('due-payment/list', { organization_id: id })
    .subscribe((resp: any)=>{
      if(resp.status){
        this.duePayments = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalViewPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.getOrganizations();
    this.getDuePayments(this.data.organization_id);
    if(this.data.id != undefined){
      this.organizationForm.get('customer_id').setValue(this.data.organization_id);
      this.organizationForm.get('due_payment_id').setValue(this.data.due_payment_id);
      this.organizationForm.get('amount').setValue(this.data.amount);
      this.organizationForm.get('detail').setValue(this.data.detail);
    }

  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

